import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { getMyAccount, getTheme } from '../api/queries';
import { themeVariables } from '../helpers/helpers';
import AppState from '../store/appstate';

function TablePagination({
  pageSize, setPageSize, pageIndex, totalPages,
  previousPage, canPreviousPage, nextPage, canNextPage, area,
}) {
  const { t } = useTranslation();
  const selectedAccount = AppState.useState((s) => s.selectedAccount);

  const myAccount = getMyAccount({
    artistaccountcode: selectedAccount,
  });

  const theme = getTheme({
    cataloguecode: myAccount?.data?.cataloguecode,
  });

  const { highlightColour } = themeVariables(theme);

  return (
    <div className="flex flex-wrap justify-end items-center pl-0 list-none my-2 mt-5 text-sm">

      <div className="w-full lg:w-auto flex justify-end">
        <select
          id={`btn${area}DisplayCount`}
          className="ml-3 mr-3 relative block rounded-lg border-1 border-gray-200 p-1 pl-2 pr-8 bg-sentric-menu-gray focus:outline-none text-sm"
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[5, 10, 20, 50, 100, 250].map((pSize) => (
            <option key={pSize} value={pSize}>
              {t('common:show-pagination')}
              {' '}
              {pSize}
            </option>
          ))}
        </select>
      </div>
      <div className="w-full flex lg:w-auto justify-end">

        <span className="ml-3 mr-3 relative block py-2 px-3">
          {t('common:page-pagination')}
          {' '}
          {pageIndex + 1}
          {' '}
          {t('common:of-pagination')}
          {' '}
          {totalPages}
        </span>
      </div>

      <div className="w-full lg:w-auto flex ml-3 mr-3 justify-end">

        <button id={`btn${area}PreviousPage`} type="button" style={{ backgroundColor: highlightColour }} className="text-sm text-white relative block py-2 px-3 leading-tight focus:outline-none rounded-l-md mr-1" onClick={() => previousPage()} disabled={!canPreviousPage}>
          <FaChevronLeft />
        </button>
        {' '}
        <button id={`btn${area}NextPage`} type="button" style={{ backgroundColor: highlightColour }} className="text-sm text-white relative block py-2 px-3 leading-tight focus:outline-none rounded-r-md" onClick={() => nextPage()} disabled={!canNextPage}>
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
}

export default TablePagination;
